/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/landing/components/UseCases.tsx
 * PURPOSE: Use Cases section - 5-industry showcase
 * SDLC FRAMEWORK VERSION: 6.1.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * DATE: 2025-12-28
 * COMPLIANCE: SDLC 6.3.1 + NQH Brand Design System V2.0
 *
 * @cross-references
 * - Design: docs/02-design/04-ui-ux-design/LOGIN-LANDING-REDESIGN-DESIGN.md
 */

import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./UseCases.module.css";

interface Industry {
  icon: string;
  nameKey: string;
  statKey: string;
}

const industries: Industry[] = [
  {
    icon: "🍜",
    nameKey: "landing.useCases.restaurant.name",
    statKey: "landing.useCases.restaurant.stat",
  },
  {
    icon: "☕",
    nameKey: "landing.useCases.cafe.name",
    statKey: "landing.useCases.cafe.stat",
  },
  {
    icon: "🏨",
    nameKey: "landing.useCases.hotel.name",
    statKey: "landing.useCases.hotel.stat",
  },
  {
    icon: "🏥",
    nameKey: "landing.useCases.clinic.name",
    statKey: "landing.useCases.clinic.stat",
  },
  {
    icon: "🧹",
    nameKey: "landing.useCases.cleaning.name",
    statKey: "landing.useCases.cleaning.stat",
  },
];

export const UseCases: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.useCases}>
      <h2 className={styles.title}>{t("landing.useCases.title")}</h2>

      <div className={styles.grid}>
        {industries.map((industry, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.icon}>{industry.icon}</div>
            <h3 className={styles.name}>{t(industry.nameKey)}</h3>
            <p className={styles.stat}>{t(industry.statKey)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
